var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-modal',[_c('template',{staticClass:"qr-wrapper",slot:"content"},[_c('img',{attrs:{"src":("data:image/png;base64," + _vm.qr)}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }